<template lang="pug">
b-form.state-create-edit-form(@submit.stop.prevent="onSumbit", novalidate)
  b-row(cols="1", cols-ms="2")
    b-col
      b-form-group(label="Nombre", label-for="name-input")
        b-form-input#name-input(
          ,
          v-model="form.name",
          :state="$v.$dirty ? !$v.form.name.$invalid : null"
        )
        div(v-if="$v.$dirty")
          b-form-invalid-feedback(:state="$v.form.name.required") Este campo es requerido
    b-col
      b-form-group(label="Color", label-for="color-select")
        v-select#color-select.color-picker(
          v-model="form.color",
          label="title",
          placeholder="Seleccione un color",
          :reduce="(color) => color.value",
          :options="options",
          :state="$v.$dirty ? !$v.form.color.$invalid : null"
        )
          template(#option="{ title, style }")
            #color-options
              span(:style="style")
              p {{ title }}
          template(#selected-option="{ title, style }")
            #color-options
              span(:style="style")
              p {{ title }}
        div(v-if="$v.$dirty")
          b-form-invalid-feedback(:state="$v.form.color.required") Este campo es requerido
    b-col
      b-form-group(label="Orden", label-for="order-input")
        b-form-input#order-input(
          v-model="form.order",
          min="0",
          type="number",
          :state="$v.$dirty ? !$v.form.order.$invalid : null"
        )
        div(v-if="$v.$dirty")
          b-form-invalid-feedback(:state="$v.form.order.required") Este campo es requerido
          b-form-invalid-feedback(:state="$v.form.order.minValue") El orden debe ser mayor o igual a cero
    b-col
      b-form-group(
        label="Representación de porcentaje de avance",
        label-for="pctProgress-input"
      )
        b-form-input#pctProgress-input(
          v-model="form.pctProgress",
          type="number",
          min="0",
          max="100",
          :state="$v.$dirty ? !$v.form.pctProgress.$invalid : null"
        )
        div(v-if="$v.$dirty")
          b-form-invalid-feedback(:state="$v.form.pctProgress.required") Este campo es requerido
          b-form-invalid-feedback(:state="$v.form.pctProgress.minValue") El porcentaje debe ser mayor a cero
          b-form-invalid-feedback(:state="$v.form.pctProgress.maxValue") El porcentaje debe ser menor o igual a 100
    b-col
      b-form-group
        b-form-checkbox#hasValue-input(
          v-model="form.hasValue",
          :state="$v.$dirty ? !$v.form.hasValue.$invalid : null"
        ) Tiene valor
        div(v-if="$v.$dirty")
          b-form-invalid-feedback(:state="$v.form.hasValue.required") Este campo es requerido
    b-col
      b-form-group
        b-form-checkbox#showResume-input(
          v-model="form.showResume",
          :state="$v.$dirty ? !$v.form.showResume.$invalid : null"
        ) Mostrar resumen
        div(v-if="$v.$dirty")
          b-form-invalid-feedback(:state="$v.form.showResume.required") Este campo es requerido
    .modal-footer
      b-btn(@click="hideModal", variant="outline-muted") Cancelar
      b-btn(type="submit") {{ action }}
</template>
<script>
import { required, minValue, maxValue } from "vuelidate/lib/validators";
import stateColors from "../../../shared/state_colors.json";
import { mapActions } from "vuex";
export default {
  props: ["action", "selected", "hideModal", "makeToast"],
  data() {
    return {
      form: {
        id: this.action === "Crear" ? null : this.selected.id,
        serviceId: this.$route.params.id,
        name: this.action === "Crear" ? "" : this.selected.name,
        color: this.action === "Crear" ? "" : this.selected.color,
        order: this.action === "Crear" ? null : this.selected.order,
        pctProgress: this.action === "Crear" ? null : this.selected.pctProgress,
        hasValue: this.action === "Crear" ? false : this.selected.hasValue,
        showResume: this.action === "Crear" ? false : this.selected.showResume,
      },
      options: stateColors,
    };
  },
  validations() {
    let validations = {
      form: {
        name: { required },
        color: { required },
        order: {
          required,
          minValue: minValue(0),
        },
        pctProgress: {
          required,
          minValue: minValue(0),
          maxValue: maxValue(100),
        },
        hasValue: { required },
        showResume: { required },
      },
    };
    return validations;
  },
  methods: {
    ...mapActions(["createServiceState", "editServiceState"]),
    async onSumbit() {
      if (this.$v.$invalid) {
        this.$v.$touch();
      } else {
        const action =
          this.action === "Crear"
            ? this.createServiceState
            : this.editServiceState;
        const data = this.form;
        const response = await action(data);
        if (response.status === 200 || response.status === 201) {
          this.makeToast("success", response.data.message, "Éxito!");
          this.hideModal();
        } else {
          this.makeToast("danger", response.data, "Ocurrió un error!");
        }
      }
    },
  },
};
</script>
<style>
#color-options {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
#color-options p {
  margin: 0;
  margin-left: 20px;
  text-align: center;
}
.color-picker .vs__dropdown-menu .vs__dropdown-option--highlight {
  background: #e4e4e4;
  color: #000;
}
</style>
